"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compound = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const ERC20_ABI = require("../../abi/erc20.json");
const CETH_ABI = require("../../abi/ceth_erc20.json");
class Compound extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            fromCToken: optimalRate.data.fromCToken,
        };
    }
    _swap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const cToken = data.fromCToken ? srcToken : destToken;
            const cContract = this.isETHAddress(srcToken) ?
                new this.web3Provider.eth.Contract(CETH_ABI, cToken) :
                new this.web3Provider.eth.Contract(ERC20_ABI, cToken);
            const value = this.isETHAddress(srcToken) ? [] : [data.srcAmount];
            const swapData = data.fromCToken ?
                cContract.methods.redeem(data.srcAmount).encodeABI() :
                cContract.methods.mint.apply(this, value).encodeABI();
            return this.swap(srcToken, destToken, data, swapData, cToken);
        });
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.Compound = Compound;
//# sourceMappingURL=compound.js.map